import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import _ from 'lodash';

class PostTypeFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectOptions: null,
      selectedOption: null,
    };
  };

  componentDidMount() {
    let selectOptions = [];
    let selectedOption = null;
    for (let i=0; i<this.props.postType.length; i++) {
      selectOptions.push(this.props.postType[i]);
      if (this.props.postType[i].active === true) {
        selectedOption = this.props.postType[i];
      }
    }
    this.setState({
      selectOptions: selectOptions,
      selectedOption: selectedOption,
    });
  }

  componentDidUpdate() {
    // See if there's a new selected option, and if so apply it
    let selectedOption = _.cloneDeep(this.state.selectedOption);
    let newSelectedOption = null;
    let selectedOptionArr = [];
    for (let i=0; i<this.props.postType.length; i++) {
      if (this.props.postType[i].active === true) {
        selectedOptionArr.push(this.props.postType[i]);
      }
    }
    // Check if there's more than one active item (default state for some page types, and we can't show more than one active post type)
    if (selectedOptionArr.length === 1) { // There's only one, so set it to the selectedOption
      newSelectedOption = selectedOptionArr[0];
    }
    selectedOption = newSelectedOption;

    // console.log('-----------------------');
    // console.log(selectedOption !== this.state.selectedOption);
    // console.log(selectedOption);
    // console.log(this.state.selectedOption);

    if (selectedOption !== this.state.selectedOption) {
      this.setState({
        selectedOption: selectedOption,
      });
    }
  };

  handleChange = (selectedOption) => {
    if (selectedOption !== null) {
      this.setState({
        selectedOption: selectedOption,
      }, function(){
        // Callback to send to Archive.js to apply the filter
        this.props.applyFilter({
          action: 'activate',
          obj: selectedOption,
        });
      });
    }
    else { // Null was passed, so deativate the selected option
      this.props.applyFilter({
        action: 'deactivate',
        obj: this.state.selectedOption,
      });
      this.setState({
        selectedOption: selectedOption,
      });
    }
  };

  handleChildChange(e, child) {
    let action = (e.target.checked) ? 'activate' : 'deactivate';
    // Find this child in selectOptions so we can pass bubble it to Archive.js
    for (let i=0; i<this.state.selectedOption.children.length; i++) {
      if (child.value === this.state.selectedOption.children[i].value) {
        this.props.applyFilter({
          action: action,
          obj: this.state.selectedOption.children[i],
        });
      }
    }
  };

  render() {
    return (
      <div className="Sidebar__filter">
        <label htmlFor='foobar'>Type</label>
        <Select
          name='foobar'
          value={this.state.selectedOption}
          onChange={this.handleChange}
          options={this.props.postType}
        />
        {(this.state.selectedOption !== null && this.state.selectedOption.children.length > 0) && (
          <ul className="Sidebar__filter-children">
            {this.state.selectedOption.children.map((item, index) =>
              <li key={index}><input id={item.value} name="post-type-radio" type="radio" onChange={function(e) { this.handleChildChange(e, item); }.bind(this)} checked={!!item.active} /><label htmlFor={item.value}>{item.label}</label></li>
            )}
          </ul>
        )}
      </div>
    );
  }
}

PostTypeFilter.propTypes = {
  applyFilter: PropTypes.func,
  label: PropTypes.string,
  postType: PropTypes.array,
  query: PropTypes.object,
};

export default PostTypeFilter;


// WEBPACK FOOTER //
// ./src/components/filters/PostTypeFilter.js